import * as React from "react";
import Icon2 from "../img/4de2ebafda9ddee8ce50cef22e146829a16b66d8dbd8dec10cdaf1465b2b9832.svg";
import Icon4 from "../img/8c99e0aaf5155bcb5a49d76fe303ea11fda45a157b7b2a1e9907bd65db3d1a19.svg";
import Icon5 from "../img/9c5d174f649db539a9c8f3bc0a557afb2153013372c36c7dbddcb34012778b0f.svg";
import Icon20 from "../img/d0065574334f667f8248239845bbb0f596264296fd239c5df7efc220b5a93792.svg";
import Icon21 from "../img/e51c39c1968b4e6b5f12273c40a97d9d0b07784bff40195363861f151febf125.svg";

function NavigationIcons() {
  const icons = [
    { src: Icon20, alt: "", width: "23px", aspect: "1.04" },
    { src: Icon5, alt: "", width: "22px", aspect: "square" },
    { src: Icon4, alt: "", width: "21px", aspect: "0.95" },
    { src: Icon21, alt: "", width: "13px", aspect: "0.59" },
    { src: Icon2, alt: "", width: "22px", aspect: "1.22" }
  ];

  return (
    // Comment out the entire navigation section
    // <nav className="flex gap-10 items-center self-stretch px-8 py-3.5 my-auto rounded-3xl bg-stone-50 min-w-[240px] max-md:px-5">
    //   {icons.map((icon, index) => (
    //     <button key={index} tabIndex="0">
    //       <img
    //         loading="lazy"
    //         src={icon.src}
    //         className={`object-contain shrink-0 self-stretch my-auto aspect-${icon.aspect} w-[${icon.width}]`}
    //         alt={icon.alt}
    //       />
    //     </button>
    //   ))}
    // </nav>
    null
  );
}

export default NavigationIcons;
